import React, { useRef } from "react";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";

import influencerImage from "~/images/influencer.svg";
import exploringBroImage from "~/images/exploring_bro.svg";
import {
  AppleLogo,
  Coin,
  GooglePlayLogo,
  Money,
  ShieldCheck,
  UsersThree,
} from "phosphor-react";
import PriceCard from "~/landingPage/pages/influencersPage/components/PriceCard";
import ReasonItem from "~/landingPage/pages/companiesPage/components/ReasonItem";
import CustomModal from "~/landingPage/components/CustomModal";
import DownloadAppButton from "~/landingPage/components/buttons/DownloadAppButton";
import {
  INFLUENCER_PREMIUM_ANNUALLY,
  INFLUENCER_PREMIUM_MONTHLY,
} from "~/utils/Constants";

export default function InfluencersPage() {
  const { setLayout } = useLayout();

  useMount(() => {
    setLayout({
      title: "Influenceurs",
      activeMenuKeys: ["influencers"],
    });
  });

  const subscribeModal = useRef();
  const downloadModal = useRef();

  return (
    <>
      <section className="flex lg:flex-row flex-col justify-center items-center lg:mt-0 mt-8">
        <div className="md:w-[48] flex flex-col justify-center lg:pl-20 px-4 gap-y-10">
          <div className="font-bold text-4xl">
            Trouvez vos premiers{" "}
            <span className="text-primary">contrats&nbsp;!</span>
          </div>
          <div>
            <div className="text-2xl">
              Entrez en contact avec des entreprises qui vous correspondent et
              proposez vos services d'influence !
            </div>
            <div className="flex md:flex-row flex-col md:space-x-10 md:space-y-0 space-y-4 justify-between md:justify-center md:items-center w-fit mt-4">
              <DownloadAppButton
                logo={<AppleLogo size="22" />}
                text={"Depuis l'App Store"}
                onclick={() => downloadModal.current?.open()}
              ></DownloadAppButton>
              <DownloadAppButton
                logo={<GooglePlayLogo size="22" />}
                text={"Depuis Google Play"}
                onclick={() => downloadModal.current?.open()}
              ></DownloadAppButton>
            </div>
          </div>
        </div>
        <div className="xl:w-[35%] w-[80%] h-[90%] flex items-center lg:justify-end justify-center px-8 mt-8 lg:mt-0">
          <img
            src={influencerImage}
            alt="présentation influenceur"
            className="max-w-[95%]"
          />
        </div>
      </section>
      <section className="w-full flex lg:flex-row flex-col-reverse justify-center items-center">
        <div className="xl:w-[35%] w-[80%] h-[90%] flex items-center lg:justify-end justify-center px-8">
          <img src={exploringBroImage} alt="aventure" />
        </div>
        <div className="lg:w-[40%] h-full flex flex-col justify-center gap-y-10 px-4">
          <div className="font-bold text-3xl lg:mt-0 mt-12">
            Révélez et profitez de votre influence&nbsp;!
          </div>
          <p className="md:text-xl text-md">
            Saisissez les opportunités de partenariats et de placement de
            produits ! <br />
            Votre influence authentique et l'engagement de vos abonnés peuvent
            ouvrir de nouvelles portes lucratives.
            <br />
            <br />
            Collaborez avec des marques qui vous ressemblent, partagez des
            produits que vous aimez et valorisez votre communauté. Profitez
            d'expériences uniques et de revenus supplémentaires. <br />
            <br />
            C'est le moment de transformer votre passion en opportunités
            concrètes !
          </p>
        </div>
      </section>
      <section className="bg-gray-100 flex flex-col justify-center items-center pt-6 pb-10">
        <div className="w-[90%]">
          <div className="font-bold text-3xl text-center mb-20 mt-10">
            Saisissez votre opportunité,{" "}
            <span className="text-primary">gratuitement&nbsp;!</span>
          </div>
          <div className="flex flex-col">
            <div className="flex md:flex-row flex-col justify-around items-center md:mb-8">
              <ReasonItem
                icon={<Coin />}
                text={
                  "Aucune commission, faites autant de partenariats et placements de produit que vous voulez !"
                }
              />
              <ReasonItem
                icon={<Money />}
                text={
                  "Une opportunité concrètes pour bénéficier de l'audience de ses réseaux sociaux !"
                }
              />
            </div>
            <div className="flex md:flex-row flex-col justify-around items-center">
              <ReasonItem
                icon={<ShieldCheck />}
                text={
                  "Des entreprises toutes vérifiées humainement. Vous ne tomberez jamais sur un faux compte !"
                }
              />
              <ReasonItem
                icon={<UsersThree />}
                text={
                  "Une équipe disponible et réactive pour répondre à toutes vos questions !"
                }
              />
            </div>
          </div>
        </div>
      </section>
      <section className="my-20 px-4">
        <h2 className="font-bold text-3xl text-center">
          Choisissez l'offre qui vous convient le mieux.
        </h2>
        <p className="text-center">
          Utilisez l'application gratuitement ou profitez de l'abonnement
          premium pour bénéficier de fonctionnalités supplémentaires
        </p>
        <div className="flex justify-center mt-6 lg:flex-row flex-col items-center">
          <PriceCard
            price={0}
            topText="Accès gratuit"
            isFree={true}
            frequency={"mois"}
            isBestOffer={false}
            onClick={() => subscribeModal.current?.open()}
          />
          <PriceCard
            price={INFLUENCER_PREMIUM_MONTHLY}
            topText="Abonnement mensuel - sans engagement"
            isFree={false}
            frequency={"mois"}
            isBestOffer={false}
            onClick={() => subscribeModal.current?.open()}
          />
          <PriceCard
            price={INFLUENCER_PREMIUM_ANNUALLY}
            topText="Abonnement annuel - sans engagement"
            isFree={false}
            frequency={"an"}
            isBestOffer={true}
            newPriceText={"Soit 6.5€/mois au lieu de 9€."}
            onClick={() => subscribeModal.current?.open()}
          />
        </div>
      </section>
      <CustomModal
        ref={subscribeModal}
        header="Inscription"
        body="L'inscription sera bientôt disponible sur le site web. En attendant, inscrivez-vous directement sur l'application mobile et choisissez l'offre qui vous convient !"
      />
      <CustomModal
        ref={downloadModal}
        header="Téléchargement"
        body={
          "L'application mobile sera très prochainement disponible sur Google Play et l'App Store, merci de patienter encore un peu. N'hésitez pas à nous contacter pour plus d'informations !"
        }
      />
    </>
  );
}
